import { CurrencyEnum, LocaleEnum } from '@systemeio/types'
import { units } from '@systemeio/util'
import { ChartOptions } from 'chart.js'
import { barChartOptions, withTooltipTitles } from 'shared/components/chart/chart-config'
import { currencyFormat } from 'shared/utils/currency-format'

interface AffiliateChartOptionsParams {
  /* Currencies in dataset order, so a hovered bar is formatted in the currency it belongs to. */
  currencies: CurrencyEnum[]
  locale?: LocaleEnum
  tooltipTitles?: string[]
}

export const getAffiliateChartOptions = ({
  currencies,
  locale,
  tooltipTitles = [],
}: AffiliateChartOptionsParams): ChartOptions<'bar'> => {
  const options = withTooltipTitles<'bar'>(barChartOptions, tooltipTitles)

  return {
    ...options,
    /* One tooltip per day lists every currency, instead of only the bar nearest the pointer. */
    interaction: { ...options.interaction, mode: 'index' },
    plugins: {
      ...options.plugins,
      tooltip: {
        ...options.plugins?.tooltip,
        callbacks: {
          ...options.plugins?.tooltip?.callbacks,
          /*
           * Chart.js hands the marker the resting fill, which is the lighter rung. The hover rung is
           * what the currency badges show, so the marker takes it too.
           */
          labelColor: ({ dataset }) => {
            const color = dataset.hoverBackgroundColor ?? dataset.backgroundColor

            return {
              borderColor: color as string,
              backgroundColor: color as string,
            }
          },
          label: ({ datasetIndex, parsed }) => {
            if (parsed.y === null) return ''

            const currency = currencies[datasetIndex]

            return currency
              ? currencyFormat(units(parsed.y), currency, locale, true)
              : String(parsed.y)
          },
        },
      },
    },
  }
}
